import { api } from '@/lib/api';

export interface MeetingPrepMeeting {
  eventId: string;
  summary: string;
  startAt: string;
  endAt: string;
  prepScore: number;
  matchedClient: string | null;
  matchedClientId: string | null;
  activeDeals: number;
  recentSignals: { title: string; severity: 'high' | 'medium' | 'low' }[];
  suggestedTopics: string[];
  calendarUrl: string | null;
  joinUrl: string | null;
}

export interface MeetingPrepResult {
  meetings: MeetingPrepMeeting[];
}

export async function getMeetingPrep(): Promise<MeetingPrepResult> {
  return api('/v1/meeting-prep');
}
